// extracted by mini-css-extract-plugin
export default {"canvaContainer":"Canva_canvaContainer__Zzp4l","imgLabel":"Canva_imgLabel__sQ2Sp","canvaButtons":"Canva_canvaButtons__lMH3w"};